import { createIcon } from './createIcon';

/** Upward arrow — submit the composer. */
export const SendIcon = createIcon({
  name: 'SendIcon',
  viewBox: '0 0 16 16',
  size: 14,
  children: (
    <path
      d="M8 13V3M8 3L3.5 7.5M8 3L12.5 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default SendIcon;
